import { render, staticRenderFns } from "./mannerAndComplane.vue?vue&type=template&id=0f7e6412&scoped=true&"
import script from "./mannerAndComplane.vue?vue&type=script&lang=js&"
export * from "./mannerAndComplane.vue?vue&type=script&lang=js&"
import style0 from "./mannerAndComplane.vue?vue&type=style&index=0&id=0f7e6412&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e6412",
  null
  
)

export default component.exports